module.exports = __webpack_public_path__ + "img/photo1_3.7589b87e.jpg";